let hiddenBody = false,
    body = document.querySelector("body");

async function detectAdBlock() {
  let bloqueado = false;
  try {
    const res1 = await fetch(new Request("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js")),
          texto = await res1.text();
    if (!res1.headers.get("content-length") || texto.includes("uBlock") ) {
      bloqueado = true;
    }

    // Verificação via elemento “bait”
    const bait = document.createElement("div");
    bait.id = "ad-test";
    bait.style.display = "none";
    document.body.appendChild(bait);
    if (!document.getElementById("ad-test")) {
      bloqueado = true;
    }

    const bait2 = document.createElement("div");
    bait2.className = "adsbygoogle";
    bait2.style.width = "1px";
    bait2.style.height = "1px";
    document.body.appendChild(bait2);
    if (bait2.offsetHeight === 0) {
      bloqueado = true;
    }
    document.body.removeChild(bait2);
  } catch (e) {
    console.error(e);
    bloqueado = true;
  } finally {
    console.log("Bloqueador detectado:", bloqueado);
  }
  return bloqueado;
}

function hideBody() {
  body.setAttribute("aria-hidden", "true");
  if (hiddenBody) {
    body.innerHTML = "";
  }
}

function showBannerAdBlock() {
  body.style.setProperty("overflow", "hidden", "important");
  body.innerHTML += getBannerAdBlockHTML();

  const script = document.createElement("script");
  script.textContent = `
    function toggleContent() {
      const conteudo = document.getElementById('content');
      const botao = document.getElementById('how-to-remove');
      if (conteudo.innerHTML.includes('<div id="content-1"')) {
        conteudo.innerHTML = \`${getContentSecondPage()}\`;
        botao.innerHTML = \`${getReturnBackButton()}\`;
      } else {
        conteudo.innerHTML = \`${getContentFirstPage()}\`;
        botao.innerHTML = \`${getHowDisableButton()}\`;
      }
    }
  `;
  body.appendChild(script);
}

function getBannerAdBlockHTML() {
  return `
    <div style="${getRandomStyle()}">
      <div style="width: 100%; max-width: 500px; margin: auto; background-color: white; border-radius: 1rem; overflow: hidden; position: relative;">
        <section id="content">
          ${getContentFirstPage()}
        </section>

        <div style="display: flex; border-top: 1px solid #E5E7EB">
          <span onclick="toggleContent()" id="how-to-remove" style="width: 50%; height: 60px; padding: 10px; text-align: center; display: flex; justify-content: center; align-items:center; cursor: pointer; background-color: white;">
            ${getHowDisableButton()}
          </span>
          <span onclick="location.reload()" style="width: 50%; height: 60px; padding: 10px; text-align: center; display: flex; justify-content: center; align-items:center; cursor: pointer; background-color: #01579B; color: white; font-weight: bold;">
            Desativei o Adblock
          </span>
        </div>
      </div>
    </div>
    <style>
      * {assinatura-jco
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }
      #ad-icon-small {
        display: none;
      }
      @media screen and (max-width: 500px) {
        #ad-icon {
          display: none;
        }
        #ad-icon-small {
          display: inline-block;
        }
      }
    </style>
  `;
}

function getRandomStyle() {
  const estilos = [
    ["width", "100%"],
    ["height", "100vh"],
    ["padding", "10px"],
    ["background-color", "rgba(0,0,0,0.68)"],
    ["position", "fixed"],
    ["top", "0"],
    ["left", "0"],
    ["z-index", "999999"],
    ["display", "flex"],
    ["font-family", "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol"],
    ["backdrop-filter", "blur(5px) grayscale(100%)"]
  ];
  return estilos.sort(() => Math.random() - 0.5)
                .map(([k, v]) => `${k}: ${v};`)
                .join(" ");
}

function getContentFirstPage() {
  return `
    <div id="content-1" style="display: flex; padding: 30px 10px 10px; min-height: 305px;">
      <div style="margin-left: 10px;">
        <div style="display:flex; justify-content: space-between;">
          <p>
            <span style="font-size: 2rem; line-height: 2rem; font-weight: bold; text-transform: uppercase; color: #01579B">Detectamos um bloqueador de anúncios!</span>
          </p>
        </div>
        <p style="font-size: 1.1rem; color: rgb(107, 114, 128); line-height: 28px; margin: 20px 0;">
          Precisamos dos anúncios para continuarmos funcionando. <br><br>Para continuar navegando sem anúncios, e também para nos ajudar com nossa independência,
          <a target="_blank" href="https://assinante.jornaldacidadeonline.com.br/apresentacao" style="color: #01579B; text-decoration: underline;">assine o JCO clicando aqui</a>.
        </p>
        <br>
        <div style="padding-bottom:1.2rem;"><a href="https://assinante.jornaldacidadeonline.com.br/" class="main-nav--subscriber" style="background-color: #01579b; font-size: 1.1rem;" rel="noopener">Já é assinante? Clique aqui</a></div>
        <br>      
      </div>
    </div>
  `;
}

function getContentSecondPage() {
  return `
    <div id="content-2" style="padding: 30px 10px 10px; min-height: 305px">
      <div style="margin-left: 10px;">
        <p style="font-weight: bold; font-size: 1.5rem; margin-bottom: 20px;">
          Como desativar o bloqueador de anúncios
        </p>
        <ol style="font-size: 1.1rem; color: rgb(107, 114, 128);">
          <li style="margin: 25px 20px;">
            Clique no ícone da extensão de bloqueio no canto superior direito.
          </li>
          <li style="margin: 25px 20px;">
            Siga as instruções para desativar o bloqueio no nosso site.
          </li>
          <li style="margin: 25px 20px;">
            Volte aqui e clique em “Desativei o Adblock” ou recarregue a página.
          </li>
        </ol>
      </div>
    </div>
  `;
}

function getHowDisableButton() {
  return "Como desativar?";
}

function getReturnBackButton() {
  return "Voltar";
}

window.onload = async () => {
  if (await detectAdBlock()) {
    hideBody();
    showBannerAdBlock();
  }
};
